import { ChangeDetectionStrategy, Component, signal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-notice-board',
  standalone: true,
  templateUrl: './notice-board.component.html',
  styleUrls: ['./notice-board.component.css'],
  imports: [CommonModule, MatExpansionModule, MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NoticeBoardComponent {
  private http = inject(HttpClient);
  readonly panelOpenState = signal(true);
  notices = signal<{ title: string; message: SafeHtml }[]>([]);
  noContent = signal(false);

  constructor(private sanitizer: DomSanitizer) {
    this.carregarNotificacoes();
  }

  private carregarNotificacoes() {
    const token = sessionStorage.getItem('token');

const headers = new HttpHeaders({
  'Authorization': `Bearer ${token}`,
  'Accept': 'application/json'
});

this.http.get<any[]>(`${environment.apiUrl}/notifications`, { headers }).subscribe({
      next: (data) => {
        if (!data || data.length === 0) {
          this.noContent.set(true);
          return;
        }

        const formatadas = data.map(item => ({
          title: item.title,
          message: this.sanitizer.bypassSecurityTrustHtml(item.introtext ?? '(Sem conteÃºdo)')
        }));

        this.notices.set(formatadas);
      },
      error: (err) => {
        console.error('Erro ao buscar notificaÃ§Ãµes:', err);
        this.noContent.set(true);
      }
    });
  }
}
